const imageLoader = ({ src, width: w, quality }) => {
  if (/^(https:)?\/\/images\.ctfassets\.net.*/.test(src)) {
    return `${src}?w=${w}&fm=webp`;
  }
  return src;
};

export default imageLoader;
